<template>
  <vxe-pager
    background
    size="mini"
    :current-page="pager.page"
    :page-size="pager.limit"
    :total="pager.totalCount"
    :layouts="pager.layouts"
    :pager-count="defaultPagerCount"
    :page-sizes="pageSizes"
    @page-change="handlePageChange"
  >
    <template v-if="!hidePagerTips" #left>{{ pagerTipsText }}</template>
  </vxe-pager>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { accDiv } from '@/utils/common';
  import type { VxePagerPropTypes } from 'vxe-table';

  export interface ITablePager {
    page?: number;
    limit?: number;
    totalCount?: number;
    layouts?: VxePagerPropTypes.Layouts;
  }
  interface ITableProps {
    hidePagerTips?: boolean;
    pagerTipsText?: string;
    pager?: ITablePager;
    pagerCount?: number;
    pageSizes?: number[];
  }
  const props = withDefaults(defineProps<ITableProps>(), {
    hidePagerTips: false,
    pagerTipsText: '左右滚动表格：shift + 鼠标滚轮',
    pager: () => ({
      layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total'],
    }),
  });
  const emits = defineEmits<{
    (e: 'pageChange', data: any): void;
  }>();

  const defaultPagerCount = computed(() => {
    if (props.pagerCount) return props.pagerCount;
    const { totalCount, limit } = props.pager;
    if (totalCount === undefined || limit === undefined) {
      return 7; // vxe默认是7
    }
    // 算出总页数，在vxe-pager组件中跳转到最后一个会用到pagerCount计算
    return Math.max(
      Math.ceil(accDiv(totalCount as number, limit as number) ?? 0),
      1
    );
  });
  // 分页相关
  const handlePageChange = (data: any) => {
    emits('pageChange', { page: data.currentPage, limit: data.pageSize });
  };
</script>

<script lang="ts">
  export default {
    // basisTable的分页组件
    name: 'Pager',
  };
</script>

<style lang="less" scoped></style>
